export default [
    {
        path: '/system/unconfirmed-users',
        name: 'unconfirmed-users',
        component: () => import('../../pages/system/UnconfirmedUsersPage.vue'),
        meta: {
            title: 'Unconfirmed Users',
            requiresAuth: true,
        },
    },
]
